import { useNuxtApp, useRoute } from "#imports";
import { toValue, ref, watch } from "vue";
import { trim } from "lodash-es";
export const HOME_URI = "__home__";
function getCurrentCraftUri(currentPath, localePrefix = "") {
  let path = toValue(currentPath);
  path = trim(path, "/");
  if (path.includes("?")) {
    path = path.substring(0, path.indexOf("?"));
  }
  if (localePrefix?.length) {
    const expression = new RegExp(`^/?${localePrefix}/?(.*)`, "i");
    const matches = path.match(expression);
    if (matches !== null && matches?.length > 0) {
      path = matches[1] || "";
    }
  }
  if (!path.length || path === "/") {
    path = HOME_URI;
  }
  return path;
}
export function useCraft() {
  const route = useRoute();
  const { $i18n } = useNuxtApp();
  const currentCraftUri = ref(getCurrentCraftUri(route.path, $i18n?.locale?.value));
  watch(() => route.path, (path) => {
    currentCraftUri.value = getCurrentCraftUri(path, $i18n?.locale?.value);
  });
  return {
    getCurrentCraftUri,
    currentCraftUri
  };
}
